










































import { Component, Vue } from 'vue-property-decorator';
import { Availability } from 'portfolio';

@Component
export default class About extends Vue {
  publicPath: string = process.env.BASE_URL
  availability: Availability = require('@/data/availability.json')
  quotes: string[] = [
    // Star Wars
    `- Hello There. - General Kenobi.`,
    `It's over Anakin, I have the high ground.`,
    // Mad Max
    `Ah, mediocre!`,
    `I live, I die, I live again!`,
    `Oh, what a day! What a lovely day!`,
    `Remember me!!`,
    `You will ride eternal, shiny and chrome!`,
    // DW
    `Bow ties are cool.`,
    `Don’t blink. Don’t even blink. Blink and you’re dead.`,
    `Hello, Sweetie.`,
    `I don't want to go.`,
    `Spoilers.`,
  ]
}
